"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkedStyles = void 0;
exports.linkedStyles = [
    '/assets/css/main.css',
    '/assets/css/custom.chunk1.css',
    '/assets/css/custom.chunk2.css',
    '/assets/css/custom.chunk3.css',
    '/assets/css/app.css',
    '/assets/css/iconsminds.css',
    '/assets/css/simple-line-icons.css'
];
